jQuery(function ($) {

    // In the `change` callback, we call `getResults()`.
    jQuery('.blog-taxonomy-ul .product-list').on('click', function (e) {
        // Starts at page #1
        var page = $('.blog-pagination .current').attr('data-href');
        $('.js-list-wrapper').find('.card-lists').addClass('blur');
        getResults(page, this);
    });

    // Wrap the AJAX call to `test_function` in a `function`.
    function getResults(page_num, this_var) {

        var pageNum = isNaN(page_num) ? 1 : page_num,
            filterValue = '',
            searchTerm  = $('#s').val(),
            taxonomy    = $('.type').attr('data');

        if ($(this_var).hasClass('type')) {
            if ($(this_var).prop("checked")) {
                filterValue = $(this_var).val();
            }
        } else {
            $.each($('.type'), function () {
                if ($(this).prop("checked")) {
                    filterValue = $(this).val();
                }
            });
        }

        $.ajax({
            type: 'GET',
            cache: true,
            url: waystar_params.endpoint,
            data: {
                _ajax_nonce: waystar_params.security,
                action: 'filter_blog',
                filter_value1: filterValue,
                taxonomy_value1: taxonomy,
                search_value: searchTerm,
                paged: pageNum
            },
            success: function (response) {
                $('.blog-list-wrapper').html(response);
                lazy_load();
                $('.js-list-wrapper').find('.card-lists').removeClass('blur');
            },
            error: function (jqXHR, textStatus, errorThrown, response) {
                $('.blog-list-wrapper').html(textStatus);
                $('.js-list-wrapper').find('.card-lists').removeClass('blur');
            }
        });
    }

    var timeoutID = null;

    function findMember(str) {
        var paged = /[\?&]paged=(\d+)/.test(this.href) && RegExp.$1;
        $('.js-list-wrapper').find('.card-lists').addClass('blur');
        getResults(paged);
    }

    $('.search-box')
        .on('keydown', function (e) {
            if (e.which === 9) { //tab
                getCurrentPage();
            }
        })
        .on('keypress', function (e) {
            if (e.which === 13) {  // enter
                getCurrentPage();
            }
        });

    $('.search-icon').on('click', function (e) {
        var search = $('.search-box').val();
        timeoutID = setTimeout(findMember(search), 500);
    });

    $(document).on('click', '.blog-pagination .page-link', function (e) {
        e.preventDefault();
        var page = $(this).attr('data-href');
        $('.js-list-wrapper').find('.card-lists').addClass('blur');
        getResults(page);
        $("html, body").animate({ scrollTop:$("#layout-content").offset().top}, 750);
    });

    function getCurrentPage() {
        var page = $('.blog-pagination .current').attr('data-href');
        $('.js-list-wrapper').find('.card-lists').addClass('blur');
        getResults(page);
    }

});